"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var faSpinner_1 = require("@fortawesome/pro-solid-svg-icons/faSpinner");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var clsx_1 = __importDefault(require("clsx"));
var LoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? '3x' : _b, className = _a.className;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('text-center', 'ds-loading-spinner', className) }, { children: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: faSpinner_1.faSpinner, pulse: true, size: size }) })));
};
exports.default = LoadingSpinner;
